<template>
  <div id="selectedProductView" class="xsmall">
    <vs-prompt
      color="warning"
      :vs-title="value.productName"
      vs-accept-text="Kaydet"
      vs-cancel-text="Vazgeç"
      vs-button-cancel="border"
      @vs-cancel="close"
      @vs-accept="save"
      @vs-close="close"
      vs-buttons-hidden
      :vs-active.sync="displayRev"
    >
      <div>
        <div v-if="value.forceBarcode" class="vx-row">
          <div class="vx-col w-full flex items-center">
            <span class="justify-start">Serino giriniz:</span>
            <vs-input type="text" class="ml-3 justify-end" @keyup="onEnter"  v-model="barcode"></vs-input>
          </div>
        </div>
        <div v-if="!value.forceBarcode" class="vx-row">
          <div class="vx-col w-full flex items-center">
            <span class="justify-start">Adet giriniz:</span>
            <vs-input type="number" class="ml-3 justify-end" @keyup="onEnter" v-model="quantity"></vs-input>
          </div>
        </div>
      </div>
    </vs-prompt>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    displaySelected: {
      type: Boolean,
      required: true,
    },
    value: "",
  },
  data() {
    return {
      barcode:"",
      quantity:0,
      barcodeTable: [
        {
          barcode: "Barkod Giriniz..",
        },
      ],
    };
  },
  mounted() {
    let a = document.querySelector("#selectedProductView input[type='text']");
    if (a){
       a.focus();
       a.select();
       return;
    }
    a = document.querySelector("#selectedProductView input[type='number']");
    if (a){
       a.focus();
       a.select();
    }
  },

  computed: {
    displayRev: {
      get() {
        return this.displaySelected;
      },
      set() {},
    },
  },
  methods: {
    close() {
      this.$emit("closeSelected");
    },
    save() {
      this.$emit("closeSelected");
    }, 
    onEnter(key) {
      if (key.keyCode == 13) {
        if(this.quantity == 0 && this.barcode == ""){
          this.$vs.notify({
              title: 'Hata!',
              text: 'Adet giriniz',
              color: 'danger',
              icon:"warning"
            });
            return;
        }
        if (this.value.forceBarcode) {
          //barkodluda pencere açık kalacak!!!
          this.$emit("quantitiy", this.value , this.barcode , true);
          let a=document.querySelector("#selectedProductView input[type='text']");
          if(a){
            a.focus();
            a.select();
          }
        } else {
          //barkodsuzda doğru giriş var ise, pencere kapanacak
          let q = parseInt(this.quantity)
          if(isNaN(q)){
            this.$vs.notify({
              title: 'Hata!',
              text: 'Adet sadece sayı olabilir',
              color: 'danger',
              icon:"warning"
            });
            return;

          }
          this.$emit("quantitiy", this.value , q , false);
          this.close();
         }

      }
    },
  },
};
</script>
<style lang="scss" scoped>
#selectedProductView {
  .con-vs-dialog .vs-dialog {
    max-height: 95%;
    width: 600px !important;
  }
  th,
  td {
    font-size: 1rem !important;
  }
}
</style>